<template>
  <Layout>
    <template #header>
      <div class="ws-header">
        <Heading>{{ $t('ppm_modal__welcome_heading') }}</Heading>
        <Subheading class="ws-subheading">
          {{ $t('ppm_modal__review_welcome_subheading') }}
        </Subheading>
      </div>
    </template>

    <template #default>
      <div class="ws-main">
        <div class="ws-main-left">
          <component
            :is="getCardComponent(paymentAccount)"
            v-if="paymentAccount"
            v-bind="getCardProps(paymentAccount)"
            class="ws-card"
          />
        </div>
        <div class="ws-main-right">
          <Paragraph>
            {{ $t('ppm_modal__review_welcome_text_p1') }}
          </Paragraph>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <Paragraph v-html="$t('ppm_modal__review_welcome_text_p2')" />
        </div>
      </div>
    </template>

    <template #footer>
      <HotPinkButton data-testid="save-ppm-button" @click="savePPM">
        {{ $t('ppm_modal__confirm_ppm_button') }}
      </HotPinkButton>

      <NavyButton
        data-testid="change-ppm-button"
        @click="$emit('go-to-select-preferred-payment-method')"
      >
        {{ $t('ppm_modal__different_ppm_button') }}
      </NavyButton>
    </template>
  </Layout>
</template>

<script>
import get from 'lodash/get'
import Layout from '../layouts/Layout.vue'
import Heading from '../typography/Heading.vue'
import Subheading from '../typography/Subheading.vue'
import Paragraph from '../typography/Paragraph.vue'
import HotPinkButton from '../buttons/HotPinkButton.vue'
import NavyButton from '../buttons/NavyButton.vue'
import CardMixin from '../mixins/CardMixin'
import PaymentFlagsMixin from '../mixins/PaymentFlagsMixin'

export default {
  components: {
    Layout,
    Heading,
    Subheading,
    Paragraph,
    HotPinkButton,
    NavyButton,
  },
  mixins: [CardMixin, PaymentFlagsMixin],
  data() {
    return {
      paymentAccount: undefined,
    }
  },
  created() {
    this.getPaymentAccount()
  },
  methods: {
    async getPaymentAccount() {
      const accounts = await this.getPaymentAccounts()
      this.paymentAccount = accounts[0]
    },
    savePPM() {
      const entityPaymentUuid = get(this.paymentAccount, [
        'entity_payment',
        'entity_payment_uuid',
      ])
      this.$emit('save-preferred-payment-method', entityPaymentUuid)
    },
  },
}
</script>

<style lang="postcss" scoped>
.ws-header {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-mb-8 tw-gap-1;
}

.ws-subheading {
  /* Base */
  @apply tw-max-w-[200px];

  /* Desktop */
  @apply lg:tw-max-w-none;
}

.ws-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-6;

  /* Desktop  */
  @apply lg:tw-flex-row lg:tw-mb-4;
}

.ws-main-left {
  /* Base */
  @apply tw-flex tw-justify-center;
}

.ws-card {
  /* Base */
  @apply tw-min-w-[264px] tw-min-h-[88px] tw-border tw-border-white;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);

  /* Desktop */
  @apply lg:tw-w-[328px] lg:tw-h-[128px];
}

.ws-main-right {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-4;
}
</style>
